/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-key */
import React from 'react';
import Grid from '@material-ui/core/Grid';

const ZodiacBottomBanner = () => {
    const banners = [
        {
            title: 'The Best Plants Based on Your Zodiac Sign',
            image: 'best_plants_zodiac_sign',
            link: 'https://www.plants.com/greenhouse/plant-care/the-household-plant-you-should-own-based-on-your-sun-sign/',
            label: 'The Best Plants',
        },
        {
            title: 'In The Stars',
            image: 'in_the_stars',
            link: 'https://www.instagram.com/plantsyoulove',
            label: 'In the Stars',
        },
    ];

    return (
        <Grid container spacing={3}>
            {banners && banners.map((banner) => (
                <Grid item md={6} className="zodiacBottomBanner">
                    <a
                        target="_blank"
                        rel="noreferrer"
                        aria-label={banner.label || 'Zodiac Bottom Banner'}
                        href={banner.link}
                    >
                        <img
                            alt={banner.title}
                            src="https://www.plants.com/images/best_plants_zodiac_sign.png"
                            width="100%"
                            height="100%"
                        />
                    </a>
                </Grid>
            ))}
        </Grid>
    );
};

ZodiacBottomBanner.propTypes = {};

export default ZodiacBottomBanner;
